import Portal from '@material-ui/core/Portal';
import { CSSProperties, ReactNode } from 'react';
import { useRedesignModalStyles } from './RedesignModal.styles';

export type RedesignModalProps = {
  open: boolean;
  /** Called when the user clicks the backdrop. */
  onClose: () => void;
  /** id of the element labelling the dialog (aria-labelledby). */
  labelledBy: string;
  /** Class styling the modal card, typically `{ ...modalPaperStyle, maxWidth: ... }`. */
  paperClassName: string;
  children: ReactNode;
  zIndex?: number;
  /** rgba(0,0,0,0.3) backdrop instead of the default 0.45. */
  lightBackdrop?: boolean;
  usePortal?: boolean;
  /** Additional overlay class. Only add properties; conflicts are unreliable. */
  overlayClassName?: string;
  /** Inline overlay overrides (deterministic, wins over classes). */
  overlayStyle?: CSSProperties;
};

const RedesignModal = ({
  open,
  onClose,
  labelledBy,
  paperClassName,
  children,
  zIndex = 1300,
  lightBackdrop = false,
  usePortal = false,
  overlayClassName,
  overlayStyle,
}: RedesignModalProps) => {
  const classes = useRedesignModalStyles();

  if (!open) {
    return null;
  }

  const content = (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <div
      className={overlayClassName ? `${classes.overlay} ${overlayClassName}` : classes.overlay}
      role="presentation"
      style={{
        zIndex,
        backgroundColor: `rgba(0, 0, 0, ${lightBackdrop ? 0.3 : 0.45})`,
        ...overlayStyle,
      }}
      onClick={event => {
        if (event.target === event.currentTarget) {
          onClose();
        }
      }}>
      <div className={paperClassName} role="dialog" aria-modal="true" aria-labelledby={labelledBy}>
        {children}
      </div>
    </div>
  );

  return usePortal ? <Portal>{content}</Portal> : content;
};

export default RedesignModal;
